import { Component, Renderer2, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { RegistrationService } from '../services/registration.service';
import { Message } from 'primeng/components/common/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  providers: [ConfirmationService]
})
export class LoginComponent implements OnInit, OnDestroy {

  loginForm: FormGroup;
  loginFormOtp: FormGroup;
  forgotpassForm: FormGroup;
  msgs: Message[] = [];
  msgsgetotp: Message[] = [];
  msgsotp: Message[] = [];
  msgsForgotPass: Message[] = [];
  forgotPassDisplay: boolean = false;
  minDateOfBirth: Date;
  maxDateOfBirth: Date;
  dateOfBirth: Date;
  maxDateOfBirthYear: number;
  minDateOfBirthYear: number;
  otpsuccessmsg: boolean = false;
  fid: any;
  otp: any;
  otpValidation: boolean = false;
  value: any;
  storedDate: any;
  dateMask: any;
  shwpasslogin = true;
  shwotplogin = false;
  otpforlogin: any;
  showotpboox = false;
  show: boolean;
  sMsgOtp: any;
  currentYear: number = new Date().getFullYear();
  nxtYrLastTwoDigit;

  emailRegEx = '^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$';
  mobRegEx = '^((\\+91-?)|0)?[0-9]{10}$';
  calDate = new Date();
  dates: Date;
  minDate: Date;
  maxDate: Date;
  invalidDates: Array<Date>


  constructor(private renderer: Renderer2, private registrationService: RegistrationService,
    private router: Router, private confirmationService: ConfirmationService, private spinner: NgxSpinnerService) {
    this.renderer.addClass(document.body, 'login-body');

  }
  ngOnInit() {
    const TODAY = new Date();
    const MONTH = TODAY.getMonth();
    const YEAR = TODAY.getFullYear();

    this.maxDateOfBirthYear = YEAR - 14;
    this.minDateOfBirthYear = YEAR - 30;

    this.minDateOfBirth = new Date();
    this.minDateOfBirth.setMonth(MONTH);
    this.minDateOfBirth.setFullYear(this.minDateOfBirthYear);

    this.maxDateOfBirth = new Date();
    this.maxDateOfBirth.setMonth(MONTH);
    this.maxDateOfBirth.setFullYear(this.maxDateOfBirthYear);

    this.dateOfBirth = this.maxDateOfBirth;

    // ===============blocked by me 1july 2020
    // localStorage.setItem('authToken','');
    // localStorage.setItem('userDetails', '');
    // localStorage.setItem('step', '');
    // localStorage.setItem('challanList', '');
    // ===============blocked by me 1july 2020


    //localStorage.clear();

    // Today Date Format(dd/mm/yyyy)
    let currentDate = TODAY.getDate();
    let currentMonth = MONTH +1;
    // let cDate = currentDate+'/'+currentMonth+'/'+this.minDateOfBirthYear;


    this.loginForm = new FormGroup({
      codenumber: new FormControl('', [Validators.required, Validators.minLength(10), Validators.pattern(this.mobRegEx)]),
      password: new FormControl('', Validators.required)
    });
    this.forgotpassForm = new FormGroup({
      moblno: new FormControl('', [Validators.required, Validators.minLength(10), Validators.pattern(this.mobRegEx)]),
      dob: new FormControl('', Validators.required)
    });

    this.nxtYrLastTwoDigit = (this.currentYear + 1).toString().substr(-2);

    // alert(1);
     //this.registrationService.pushWhatsAppNotification();

  }

  showotplogin() {
    this.loginFormOtp = new FormGroup({
      mobno: new FormControl('', Validators.required, Validators.pattern['/^[6-9]\d{9}$/'])
    });
    this.shwotplogin = true;
    this.shwpasslogin = false;
    this.showotpboox = false;
  }

  showpasslogin() {
    this.shwotplogin = false;
    this.shwpasslogin = true;
    this.showotpboox = false;
  }

  password() {
    this.show = !this.show;
  }


  onSubmit() {
    if (this.loginForm.valid) {
      this.spinner.show();
      const data = this.loginForm.value;
      this.registrationService.studentLogin(data).then(res => {
        this.spinner.hide();
        //console.log(res.step);
        // console.log(res);
        if (res.status === 'success') {
          localStorage.setItem('authToken', res.authToken);
          localStorage.setItem('userDetails', JSON.stringify(res.userDetails));
          localStorage.setItem('step', res.step);
          if (res.step) {
            this.router.navigateByUrl('admission/' + res.step + '-information');
          } else {
            this.router.navigateByUrl('candidate/dashboard');
          }
        } else {
          this.msgs = [];
          this.msgs.push({ severity: 'error', summary: 'Wrong UserId or password' });
        }
      });
    } else {
      Object.keys(this.loginForm.controls).forEach(control => {
        this.loginForm.controls[control].markAsDirty();
      });
    }
  }

  getOTPLogin() {
    this.spinner.show();
    if (this.loginFormOtp.valid) {
      // console.log(this.loginFormOtp.value)
      const data = this.loginFormOtp.value.mobno;
      this.registrationService.studentLoginotp(data).then(res => {
        // console.log(res)
        this.spinner.hide();
        // console.log(res.step);
        if (res.status === 'success') {
          localStorage.setItem('mb', data);
          this.showotpboox = true;
          this.shwotplogin = false;
          this.msgsotp = [];
          const dltid = res.dltid;
          const mask = res.mask;
          const mobno = res.mobno;
          const pw = res.pw;
          const un = res.un;
          const sub = res.sub;
          const name = res.name;
          const emlbody = res.emlbody;
          const emlpw = res.emlpw;
          const emlsendto = res.emlsendto;
          const emlsub = res.emlsub;
          const emlun = res.emlun
          this.registrationService.giveMsgForMob(dltid, mask, mobno, pw, un, sub).then(response => {
            // console.log('SMS sent successfully:', response);
          })
            .catch(error => {
              alert(error.message);
            });
          this.registrationService.giveMsgForEmail(name, emlun, emlpw, emlsub, emlbody, emlsendto).then(response => {
            // console.log('SMS sent successfully:', response);
          })
            .catch(error => {
              alert(error.message);
            });
          this.msgsotp.push({ severity: 'success', summary: "OTP has been sent to your registered mobile number and email ID" });
          // this.sMsgOtp = "OTP has been sent to your registered mobile number and email ID";
        } else {
          this.msgsgetotp = [];
          this.msgsgetotp.push({ severity: 'error', summary: res.message });
        }
      });
    } else {
      this.spinner.hide();

      Object.keys(this.loginFormOtp.controls).forEach(control => {
        this.loginFormOtp.controls[control].markAsDirty();
      });
    }
  }

  verifyOtpForLogin() {
    if (this.otpforlogin === undefined) {
      this.otpValidation = true;
    } else {
      this.spinner.show();
      this.otpValidation = false;
      this.registrationService.verifyOtpforlogin(localStorage.getItem('mb'), this.otpforlogin).then(res => {
        // console.log(res);
        this.spinner.hide();
        if (res.status === 'success') {
          localStorage.setItem('authToken', res.authToken);
          localStorage.setItem('userDetails', JSON.stringify(res.userDetails));
          localStorage.setItem('step', res.step);
          if (res.step) {
            this.router.navigateByUrl('admission/' + res.step + '-information');
          } else {
            this.router.navigateByUrl('candidate/dashboard');
          }
        } else {
          this.msgsotp = [];
          this.msgsotp.push({ severity: 'error', summary: res.message });
        }
      });
    }
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'login-body');
    localStorage.removeItem('mb');
  }

  showPopupForgotPass() {
    this.forgotPassDisplay = true;
  }

  getOtp() {
    if (this.forgotpassForm.valid) {
      const data = this.forgotpassForm.value;
      const d = new Date(Date.parse(this.forgotpassForm.value.dob));
      if (this.value === undefined) {
        this.storedDate = d.getDate() + '/' + (d.getMonth() + 1) + '/' + d.getFullYear();
      } else {
        this.storedDate = this.value;
      }
      data.dob = this.storedDate;
      //console.log(data);
      this.confirmationService.confirm({
        message: "You will receive OTP in your Registered Mobile Number and Email. Press 'Yes' to continue.",
        header: 'Confirmation',
        //icon: 'fa fa-question-circle',
        accept: () => {
          this.registrationService.getOTP(data).then(res => {
            // console.log(res);
            if (res.status === 'success') {
              this.otpsuccessmsg = true;
              this.fid = res.id;
              const dltid = res.dltid;
              const mask = res.mask;
              const mobno = res.mobno;
              const pw = res.pw;
              const un = res.un;
              const sub = res.sub;
              const name = res.name;
              const emlbody = res.emlbody;
              const emlpw = res.emlpw;
              const emlsendto = res.emlsendto;
              const emlsub = res.emlsub;
              const emlun = res.emlun
              this.registrationService.giveMsgForMob(dltid, mask, mobno, pw, un, sub).then(response => {
                // console.log('SMS sent successfully:', response);
              })
                .catch(error => {
                  alert(error.message);
                });
              this.registrationService.giveMsgForEmail(name, emlun, emlpw, emlsub, emlbody, emlsendto).then(response => {
                // console.log('SMS sent successfully:', response);
              })
                .catch(error => {
                  alert(error.message);
                });
            } else {
              alert(res.msg);

              this.forgotpassForm.reset();
            }
          });
        },
        reject: () => {
          this.otpsuccessmsg = false;
          this.forgotPassDisplay = false;
          this.forgotpassForm.reset();
        }
      });
    }
    else {
      console.log('Form Not Submitted!');
      // console.log(this.forgotpassForm);
      Object.keys(this.forgotpassForm.controls).forEach(control => {
        this.forgotpassForm.controls[control].markAsDirty();
      });
    }
  }

  getPass(fid, otp) {
    if (otp === undefined) {
      this.otpValidation = true;
    } else {
      this.otpValidation = false;
      this.registrationService.getPassword(fid, otp).then(res => {
        // console.log(res);
        if (res.status === 'success') {
          alert(res.msg);
          this.otp = '';
          this.fid = '';
          const dltid = res.dltid;
          const mask = res.mask;
          const mobno = res.mobno;
          const pw = res.pw;
          const un = res.un;
          const sub = res.sub;
          const name = res.name;
          const emlbody = res.emlbody;
          const emlpw = res.emlpw;
          const emlsendto = res.emlsendto;
          const emlsub = res.emlsub;
          const emlun = res.emlun
          this.registrationService.giveMsgForMob(dltid, mask, mobno, pw, un, sub).then(response => {
            // console.log('SMS sent successfully:', response);
          })
            .catch(error => {
              alert(error.message);
            });
          this.registrationService.giveMsgForEmail(name, emlun, emlpw, emlsub, emlbody, emlsendto).then(response => {
            // console.log('SMS sent successfully:', response);
          })
            .catch(error => {
              alert(error.message);
            });
          this.forgotpassForm.reset();
          this.forgotPassDisplay = false;
          this.otpsuccessmsg = false;
        } else {
          alert(res.msg);

        }
      });
    }
  }

  onInputDate(event): void {
    let cursorPosition = event.target.selectionEnd;

    if (event.inputType === 'deleteContentBackward' && (cursorPosition === 2 || cursorPosition === 5)) {
      event.target.value = event.target.value.substring(0, cursorPosition - 1) + event.target.value.substring(cursorPosition);
      cursorPosition--;
    }
    if (event.inputType === 'insertText' && (event.target.value.length > 10)) {
      event.target.value = event.target.value.substring(0, event.target.value.length - 1);
    }

    this.dateMask = event.target.value.toString();
    this.dateMask = this.dateMask.replace(/\D/g, '');

    let mask = '';
    for (let i = 0; i < this.dateMask.length; i++) {
      mask += this.dateMask[i];
      if (i === 1 || i === 3) {
        mask += '/';
        if (cursorPosition === 2 || cursorPosition === 5) { cursorPosition++; }
      }
    }
    event.target.value = mask.toString();
    event.target.selectionStart = cursorPosition;
    event.target.selectionEnd = cursorPosition;

    if (event.target.value.length === 10) {
      //console.log(event.target.value);
      this.value = event.target.value;
      this.storedDate = this.value;
      // const dt = this.stringToDate(event.path[0].value);
      // if (this.isValidDate(dt)) {
      //     this.value = dt;
      // }
    }
  }

  onBlurDate(): void {
    //console.log(this.value);
    const d = new Date(Date.parse(this.forgotpassForm.value.dob));
    if (this.value == undefined) {
      this.storedDate = d.getDate() + '/' + (d.getMonth() + 1) + '/' + d.getFullYear();
      //console.log(this.storedDate);
    } else {
      this.storedDate = this.value;
      //console.log(this.storedDate);
    }
    // if (!!this.value && !this.isValidDate(this.value)) {
    //     this.value = null;
    // }
  }
  applicationprocess() {
    window.open("https://thebges.edu.in/wp-content/uploads/2019/05/App-Procedure.pdf")
  }

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts